<script setup>
// eslint-disable-next-line no-unused-vars
const props = defineProps({
    testId: {
        type: String,
        default: "",
    },
    dataTest: {
        type: String,
        default: "",
    },
    componentId: {
        type: String,
        default: "",
    },
    type: {
        type: String,
        default: "primary",
    },
    size: {
        type: String,
        default: "default",
    },
    buttonType: {
        type: String,
        default: "button",
    },
});

const emit = defineEmits(["click"]);
</script>

<template>
    <button
        :type="[buttonType]"
        :data-test-id="testId"
        :data-test="dataTest"
        @click="emit('click')"
        class="basic-button-class"
        :class="[type, size]"
        :id="componentId"
    >
        <slot></slot>
    </button>
</template>

<style scoped>
button.basic-button-class {
    display: block;
    border-radius: 10px;
    min-height: 46px;
    font-weight: 700;
    font-size: 0.75rem;
    line-height: 1.125rem;
}

.default {
    padding: 0.875rem 1.5rem;
}

.small {
    padding: 0.5625rem 1.5rem !important
}

.primary {
    background: #260045;
    color: #ffffff;
    border: 1px solid #260045;
    text-decoration: none;
}

.outline {
    background: #ffffff;
    color: #260045;
    border: 1px solid #260045;
    text-decoration: none;
}

.warning {
    background: #EB4247;
    color: #ffffff;
    border: 1px solid #EB4247;
    text-decoration: none;
}

.sub {
    padding: 0;
    height: max-content;
    display: inline;
    background-color: white;
    border: 0;
    font-weight: 900;
    color: #260045;
    font-size: 0.875rem !important;
}

.get-started {
    padding: 9px 53px;
}

button:focus {
    outline: 0;
}

button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
</style>
